<div class="d-flex gap-2">
  <div>{{this.data.name}}</div>
  <svg-icon src="assets/icons/check.svg" *ngIf="data.issocial" [matTooltip]="'Siège social'"></svg-icon>
</div>
